// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"a7f8e8f7","316":"2a7c7f0e","584":"0dc6246a","995":"a6cabf17"}[chunkId] + ".chunk.js";
};